<template>
  <div>
    <v-footer app>
      <span>&copy; {{ new Date().getFullYear() }} CSdocs</span>
      <v-spacer></v-spacer>
      <!-- 
        <span class="clickable-link" @click="handleClick">Release Notes</span>
      -->
      <a style="text-decoration:none; color:black" class="clickable-link" href="https://www.csgi.com/privacy/privacy-notice/" target="_blank" rel="noopener noreferrer"><span class="clickable-link">Privacy Policy</span></a>
      <span style="padding-right: 10px;">|</span>
      <span style="padding-right: 10px;">V1.20</span>
    </v-footer>
    <ReleaseNotes ref="releaseNotesModal" />
  </div>
</template>

<script>
import ReleaseNotes from './ReleaseNotesPDF.vue';
import { mapState } from 'vuex';

export default {
  components: {
    ReleaseNotes,
  },
  methods: {
    handleClick() {
      // Open the ReleaseNotes modal
      this.$refs.releaseNotesModal.open();
    },
  },
  computed: {
    ...mapState(['user', 'showReleaseNotes']),
  },
};
</script>

<style>
.clickable-link {
  padding-right: 10px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
